import { React, useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate, useParams } from "react-router-dom";
import arrowDown from "../../../images/arrow-down.svg";
import NoIndex from "../../NoIndex";
import MyContext from "../../../MyContext";
import "../AdminDashboard.css"

const CampaignView = () => {
   const { clientId,number,CampaignId,campaignName } = useParams();
  const { baseUrl, config } = useContext(MyContext)
  const [isOpen, setIsOpen] = useState(false);
  const [userID, setuserID] = useState(clientId);
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const navigate = useNavigate();
  const [animate, setAnimate] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [template, settemplate] = useState({});
  const [camp, setcamp] = useState({})
  const [campaignId, setCampaignId] = useState(CampaignId);
  const [campaignPhoneId, setcampaignPhoneId] = useState();

  // Hook to get the current URL location
  const location = useLocation();

  // Function to extract query parameters from the URL
  // const getQueryParams = () => {
  //   const searchParams = new URLSearchParams(location.search);
  //   const id = searchParams.get("campaignId");
  //   const name = searchParams.get("campaignName");
  //   setCampaignId(id);
  //   setcampaignPhoneId(name);
  // };
  useEffect(() => {
    setAnimate(false);
    setTimeout(() => setAnimate(true), 10);
  }, [template]);

  // Fetch query parameters on component mount
  // useEffect(() => {
  //   getQueryParams();
  // }, [location.search]);

  const handleEditClick = (campaignId, campaignName) => {
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("campaignId");
    const name = searchParams.get("campaignName");
    console.log("Clicked row with campaignId:", id);
    console.log("Clicked row with campaignName:", name);
    // navigate(`/Dashboard`);

    navigate(`/CampaignDetails?campaignId=${id}&campaignName=${name}`);
  };

  const [Campaign, setCampaign] = useState([]);

  const getCampaign = async (e) => {
    try {
      var raw = JSON.stringify({
        userid: userID,
        campaignName: campaignName,
        phoneNumberId: campaignPhoneId
      });

      var requestOptions = {
        method: "POST",
        headers: config.headers,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${baseUrl}/api/Campaign/v1.0/getCampaigns`,
        requestOptions
      );

      const data = await res.json();

      if (data?.responseCode == "00") {
        setCampaign(data?.data);

      } else {
      }
    } catch (error) {
      console.log({ error });
    }
  };

  useEffect(() => {
    getCampaign();
  }, [campaignPhoneId]);
  const getTemplates = async () => {
    try {
      const raw = JSON.stringify({
        userid: userID,
      });

      const requestOptions = {
        method: "POST",
        headers: config.headers,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${baseUrl}/api/Whatsapp/getTemplates`,
        requestOptions,
      );

      const data = await res.json();

      if (data?.responseCode === "00") {
        setTemplates(data?.response?.data);
      } else {
        console.error("Failed to fetch templates");
      }
    } catch (error) {
      console.error("Error fetching templates:", error);
    }
  };

  useEffect(() => {
    getTemplates();
  }, []);

  useEffect(() => {

    if (Campaign) {
      Campaign?.map((item) =>
        item.id === campaignId ? setcamp(item) : ""
      )
    }
    if (templates) {
      templates?.map((temp, index) =>
        temp.name === camp?.template_id ? settemplate(temp) : ""
      )
    }

  }, [templates, Campaign])
  useEffect(() => {
    console.log(template)
  }, [template])

  const replaceVariablesBody = (text) => {
    const replacements = ["John Doe", "Messaging"]; // Replace with dynamic values
    return text.replace(/{{(\d+)}}/g, (_, index) => replacements[index - 1] || "");
  };

  return (
    <div className="marginRight">
      <NoIndex />
      <div
        className="p-4 bg-white "
        style={{
          height: "100vh",
          fontFamily: "Nunito,sans-serif",
        }}
      >
        <div className=" px-4  justify-content-center">
          <div className="d-flex justify-content-between">
            <p className="CreateCampaign">Campaign Details </p>
            {/* <p>
              {" "}
              <button
                className="blue-button p-2 px-4 me-3 text-white"
                onClick={() => handleEditClick()}
              >
                Edit
              </button>
            </p> */}
          </div>
          <div className=" px-2">
            <div
              class="p-4 row col-12"
              style={{
                borderRadius: "10px",
                border: "1px solid #ccc",
                // backgroundColor: "rgba(1, 195, 125, 0.05)",
              }}
            >
              {Campaign.map((item) => (
                <>
                  {item.id === campaignId ? (
                    <div>
                      {
                        <>
                          <div className="campaign-detail-info">
                            <div
                              className="campaign-detail-header"
                              onClick={toggleDropdown}
                            >
                              Campaign Info
                              <span
                                className={`campaign-detail-arrow ${isOpen ? "campaign-detail-open" : ""
                                  }`}
                              >
                                <img src={arrowDown} />
                              </span>
                            </div>
                            <div
                              className={`campaign-detail-dropdown-content ${isOpen ? "campaign-detail-open" : ""
                                }`}
                            >
                              <table class="table">
                                <thead>
                                  <tr>
                                    <th scope="col">Campaign Name:</th>
                                    <td scope="col">{item.campaign_name}</td>
                                    <th scope="col">Template Name:</th>
                                    <td scope="col">{item.template_id}</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <th scope="row">Start Date:</th>
                                    <td>{item.campaign_start}</td>
                                    <th>End Date:</th>
                                    <td>{item.campaign_end}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Audience excel:</th>
                                    <td><a href={item.excel_url}>{item.excel_url}</a></td>
                                    <th>Channel:</th>
                                    <td>{item.channel}</td>
                                  </tr>

                                </tbody>
                              </table>

                            </div>
                          </div>

                          <hr className="text-3-2" />
                          <div className="d-flex justify-content-between gap-2">
                            <div
                              style={{
                                border: "1px solid #007bff",
                                backgroundColor: "rgba(0, 123, 255, 0.1)",
                                color: "#007bff",
                                textAlign: "center",
                                width: "50%",
                                borderRadius: "5px",
                                padding: "10px",
                              }}
                            >
                              Total Read <p style={{ fontWeight: "bold" }}>{item.read}</p>
                            </div>

                            <div
                              style={{
                                border: "1px solid #28a745",
                                backgroundColor: "rgba(40, 167, 69, 0.1)",
                                color: "#28a745",
                                textAlign: "center",
                                width: "50%",
                                borderRadius: "5px",
                                padding: "10px",
                              }}
                            >
                              Total Delivered <p style={{ fontWeight: "bold" }}>{item.delivered}</p>
                            </div>

                            <div
                              style={{
                                border: "1px solid #17a2b8",
                                backgroundColor: "rgba(23, 162, 184, 0.1)",
                                color: "#17a2b8",
                                textAlign: "center",
                                width: "50%",
                                borderRadius: "5px",
                                padding: "10px",
                              }}
                            >
                              Accepted <p style={{ fontWeight: "bold" }}>{item.accepted}</p>
                            </div>

                            <div
                              style={{
                                border: "1px solid #dc3545",
                                backgroundColor: "rgba(220, 53, 69, 0.1)",
                                color: "#dc3545",
                                textAlign: "center",
                                width: "50%",
                                borderRadius: "5px",
                                padding: "10px",
                              }}
                            >
                              Failed <p style={{ fontWeight: "bold" }}>{item.failed}</p>
                            </div>

                            <div
                              style={{
                                border: "1px solid #ffc107",
                                backgroundColor: "rgba(255, 193, 7, 0.1)",
                                color: "#ffc107",
                                textAlign: "center",
                                width: "50%",
                                borderRadius: "5px",
                                padding: "10px",
                              }}
                            >
                              Total Responded <p style={{ fontWeight: "bold" }}>{item.responded}</p>
                            </div>

                            <div
                              style={{
                                border: "1px solid #6f42c1",
                                backgroundColor: "rgba(111, 66, 193, 0.1)",
                                color: "#6f42c1",
                                textAlign: "center",
                                width: "50%",
                                borderRadius: "5px",
                                padding: "10px",
                              }}
                            >
                              Total Sent <p style={{ fontWeight: "bold" }}>{item.sent}</p>
                            </div>







                          </div>
                          <div className="d-flex justify-content-between">   {
                            template && <div className=" border rounded w-50 mt-4 p-2">
                              <div className="campaignheading ms-2">Template Details</div>
                              <div className="ms-2">
                                <div className="col-md-6 mb-1">
                                  <div className="p-1">
                                    <h5 className="text-dark">Name</h5>
                                    <p>{template.name}</p>
                                  </div>
                                </div>
                                <div className="col-md-6 mb-1">
                                  <div className="p-1">
                                    <h5 className="text-dark">Category</h5>
                                    <p>{template.category}</p>
                                  </div>
                                </div>
                                <div className="col-md-6 mb-1">
                                  <div className=" p-1">
                                    <h5 className="text-dark">Status</h5>
                                    <p>{template.status}</p>
                                  </div>
                                </div>
                                <div className="col-md-6 mb-1">
                                  <div className="p-1">
                                    <h5 className="text-dark">Language</h5>
                                    <p>{template.language}</p>
                                  </div>
                                </div>
                              </div>
                              <div className="mt-1 ms-2">
                                {template?.components?.map((component, index) => (
                                  <div key={index} className="col-md-6 mb-1">
                                    <div className="p-1">
                                      <h5 className="text-dark">{component.type}</h5>
                                      <p>{component.text}</p>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          }         {template && (
                            <div className="col-12 col-md-3 mt-md-0">
                              <div className="mobile-card mt-4" style={{ position: "relative" }}>
                                <div className="mobile-btn1"></div>
                                <div className="mobile-btn2"></div>
                                <div className="mobile-btn3"></div>
                                <div className="mobile-btn4"></div>
                                <div className="mobile-card-int">
                                  <div className="bubble-container">
                                    <div className={`message-bubble ${animate ? "message-bubble-animate" : ""}`}>
                                      {template?.components?.find(item => item.format === "VIDEO")?.example?.header_handle?.[0] ? (
                                        <video width="90%" height="200px" controls>
                                          <source
                                            src={templates?.components?.find(item => item.format === "VIDEO")?.example?.header_handle?.[0]}
                                            type="video/mp4"
                                          />
                                          Your browser does not support the video tag.
                                        </video>
                                      ) : template?.components?.find(item => item.format === "IMAGE")?.example?.header_handle?.[0] ? (
                                        // Check if image exists and display it
                                        <img
                                          src={template?.components?.find(item => item.format === "IMAGE")?.example?.header_handle?.[0]}
                                          alt="Template Image"
                                          style={{ maxWidth: "90%", borderRadius: "8px" }}
                                        />
                                      ) : null}
                                      {/* HEADER */}
                                      <div className="header-text">
                                        {template.components?.find(c => c.type === "HEADER")?.text || ""}
                                      </div>

                                      {/* BODY */}
                                      <div className="body-text py-1">
                                        <div>
                                          {replaceVariablesBody(template.components?.find(c => c.type === "BODY")?.text || "")}
                                        </div>
                                      </div>

                                      {/* FOOTER */}
                                      <div className="footer-text">
                                        {template.components?.find(c => c.type === "FOOTER")?.text || ""}
                                      </div>

                                      <div className="footer-text text-end">05:27 PM</div>
                                    </div>

                                    {/* BUTTONS */}
                                    {template.components
                                      ?.find(c => c.type === "BUTTONS")?.buttons?.map((button, index) => (
                                        <div key={index} className={`button-bubble ${animate ? "button-bubble-animate" : ""}`}>
                                          <div className="button-text text-success text-center mb-1">
                                            {button.text}
                                          </div>
                                        </div>
                                      ))}
                                  </div>
                                </div>
                                <div className="mobile-top">
                                  <div className="mobile-camera">
                                    <div className="mobile-int"></div>
                                  </div>
                                  <div className="mobile-speaker"></div>
                                </div>
                              </div>
                            </div>
                          )}</div>



                        </>
                      }
                    </div>
                  ) : (
                    ""
                  )}
                </>
              ))}
            </div>

          </div>
        </div>
      </div>


    </div>
  );
};

export default CampaignView;